import { render, staticRenderFns } from "./PlaySvg.vue?vue&type=template&id=2b19a8a3&scoped=true&"
import script from "./PlaySvg.vue?vue&type=script&lang=js&"
export * from "./PlaySvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19a8a3",
  null
  
)

export default component.exports